import React from 'react'

import "./FilterProducts.css"
import { Checkbox, CheckboxProps, Collapse } from 'antd'

interface Props{
   filterCategory:string[]
   setFilterCategory: React.Dispatch<React.SetStateAction<string[]>>
   filterTCG:string[]
   setFilterTCG: React.Dispatch<React.SetStateAction<string[]>>
   filterTipo:string[]
   setFilterTipo:React.Dispatch<React.SetStateAction<string[]>>
   filterIdioma:string[]
   setFilterIdioma: React.Dispatch<React.SetStateAction<string[]>>
   loading:boolean

}

const FilterProducts = ({filterIdioma, filterTCG, filterTipo, setFilterIdioma, setFilterTCG, setFilterTipo, loading, filterCategory, setFilterCategory}:Props) => {

  const onChangeCategory: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterCategory(prev => [...prev, value]);
    } else {
      setFilterCategory(prev => prev.filter(item => item !== value));
    }
  };

  const onChangeTCG: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterTCG(prev => [...prev, value]);
    } else {
      setFilterTCG(prev => prev.filter(item => item !== value));
    }
  };

  const onChangeTipo: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterTipo(prev => [...prev, value]);
    } else {
      setFilterTipo(prev => prev.filter(item => item !== value));
    }
  };

  const onChangeIdioma: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterIdioma(prev => [...prev, value]);
    } else {
      setFilterIdioma(prev => prev.filter(item => item !== value));
    }
  };


  return (
    <div className='filter-Products-container'>
          <div className='filter-products-section'>
            <Collapse
              defaultActiveKey={['1']}
            items={[{ key: '1', label: 'Categoría', children: <div className='filter-products-elements' > 
                <Checkbox value={"TCG"} onChange={onChangeCategory} disabled={loading} >TCG</Checkbox>
                <Checkbox value={"figura"} onChange={onChangeCategory} disabled={loading}>Figuras</Checkbox>
            </div> }]}
            />
        </div>
        <div className='filter-products-section'>
            <Collapse
              defaultActiveKey={['1']}
            items={[{ key: '1', label: 'TCG', children: <div className='filter-products-elements' > 
                <Checkbox value={"pokemon"} onChange={onChangeTCG} disabled={loading} >Pokemon</Checkbox>
                <Checkbox value={"yugioh"} onChange={onChangeTCG} disabled={loading}>Yugioh</Checkbox>
                <Checkbox value={"lorcana"} onChange={onChangeTCG} disabled={loading}>Lorcana</Checkbox>
                <Checkbox value={"one piece"} onChange={onChangeTCG} disabled={loading}>One Piece</Checkbox>
                <Checkbox value={"otro"} onChange={onChangeTCG} disabled={loading}>Otros</Checkbox>

            </div> }]}
            />
        </div>

        <div className='filter-products-section'>
            <Collapse
            defaultActiveKey={['1']}
            items={[{ key: '1', label: 'Tipo', children: <div className='filter-products-elements'> 
                <Checkbox value={"deck"} onChange={onChangeTipo} disabled={loading}>Deck</Checkbox>
                <Checkbox value={"booster box"} onChange={onChangeTipo} disabled={loading}>Booster box</Checkbox>
                <Checkbox value={"sobre"} onChange={onChangeTipo} disabled={loading}>Sobres</Checkbox>
                <Checkbox value={"protector"} onChange={onChangeTipo} disabled={loading}>Protectores</Checkbox>

            </div> }]}
            />
        </div>


                <div className='filter-products-section'>
            <Collapse
            defaultActiveKey={['1']}
            items={[{ key: '1', label: 'Idioma', children: <div className='filter-products-elements'> 
                <Checkbox value={"ingles"} onChange={onChangeIdioma} disabled={loading}>Ingles</Checkbox>
                <Checkbox value={"chino"} onChange={onChangeIdioma} disabled={loading}>Chino</Checkbox>
                <Checkbox value={"japones"} onChange={onChangeIdioma} disabled={loading}>Japones</Checkbox>
                <Checkbox value={"espanol"} onChange={onChangeIdioma} disabled={loading}>Español</Checkbox>

            </div> }]}
            />
        </div>

    </div>
  )
}

export default FilterProducts